import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CInput,
  CInputGroup,
  CLabel,
  CRow,
} from "@coreui/react";
import React, { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Auth from "src/auth";
import { apiCall } from "src/_apiConfig/apiCall";
import ConfirmationPopup from "../common/ConfirmationPopup";

const OfflinePaymentWithType = () => {
  const { authenticated } = Auth();
  const { lotid, type } = useParams();
  const [selectedFile, setSelectedFile] = useState();
  const [amount, setamount] = useState();
  const [bgid, setbgid] = useState();
  const [bgduedate, setbgduedate] = useState();
  const history = useHistory();

  console.log("LOG-1" + lotid + " " + type);
  const decrypted = window.atob(lotid);
  console.log("LOG-1" + decrypted + " " + type);
  //Confirmation popup------------------------------------
  const [CPopUpId, setCPopUpId] = useState();
  const [CPopUpIndex, setCPopUpIndex] = useState();
  const [CPopUpDisplayConfirmationModal, setCPopUpDisplayConfirmationModal] =
    useState(false);
  const [CPopUpBodyText, setCPopUpBodyText] = useState();

  const handleConfirmationPopUpModalClose = () =>
    setCPopUpDisplayConfirmationModal(false);
  //-------------------------------------------------------
  const backToListViewHandler = async (e) => {
    history.push(`/lotlistview/${lotid}`, {
      from: window.location.href,
    });
  };

  const ConfirmationPopupHandler = async (
    popupid,
    popupindex,
    popupbodytext
  ) => {
    setCPopUpId(popupid);
    setCPopUpIndex(popupindex);
    setCPopUpDisplayConfirmationModal(true);
    setCPopUpBodyText(popupbodytext);
  };

  const SubmitConfirmationPopUpResponse = async () => {
    submitHandler();
  };

  const submitHandler = async () => {
    // e.preventDefault();
    const header = new Headers();
    const data = new FormData();
    data.append("file", selectedFile);
    header.append("Accept", "application/json");
    const response = await apiCall(`BG/Upload`, "POST", header, data);
    const jsonobj = await response.json();
    if (response.status === 200) {
      header.append("Content-Type", "application/json");
      let URL = "BG/Add";

      if (type === "transferemd") {
        URL = "BG/TransferLotEMD15";
      } else if (type === "transferemdfee") {
        URL = "BG/TransferLotEMDFee";
      } else if (type === "AddInstallemntAmt") {
        URL = "BG/InstallmentAmt60PerBG";
      }
      const uploadResponse = await apiCall(
        URL,
        "POST",
        header,
        JSON.stringify({
          bgid: bgid,
          bgduedate: bgduedate,
          bgamount: Number(amount),
          lotid: Number(decrypted),
          userid: authenticated.userId,
          filePath: jsonobj,
        })
      );
      const uploadjsonobj = await uploadResponse.json();
      if (
        uploadResponse.status === 200 &&
        uploadjsonobj !== -1 &&
        uploadjsonobj !== -2
      ) {
        history.push(`/lotlistview/${lotid}`, {
          from: window.location.href,
        });
      }
    }
  };

  return (
    <CCard className={"shadow-sm"}>
      <CCardHeader>
        <CRow className="pt-3" xl={12}>
          <CCol xl={10}>
            <h3>Bank Guarantee Payment</h3>
          </CCol>
        </CRow>
      </CCardHeader>
      <CCardBody>
        <CRow className=" pl-3 mb-4">
          <CCol xl={12} className={"blockquote"} style={{ fontSize: "large" }}>
            <strong>Note:</strong>
            <span className="">
              {" "}
              &nbsp; If you are uploading a BG/FDR of 15% by combining a 10% and
              a 5% BG/FDR, you must sum the amounts of both BGs/FDRs, enter both
              BG/FDR numbers in the remarks, set the BG/FDR due date to the
              latest date from both BGs/FDRs, combine both BG/FDR documents into
              a single PDF, and then upload it.
            </span>
          </CCol>
        </CRow>

        <CForm className="needs-validation">
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
                Upload Payment Receipt :
              </CLabel>
            </CCol>

            <CCol xl={4}>
              <CInputGroup className="mb-3">
                <div className="custom-file">
                  <input
                    id="inputGroupFile01"
                    type="file"
                    accept=".jpg, .jpeg, .png"
                    className="custom-file-input"
                    onChange={(e) => {
                      setSelectedFile(e.target.files[0]);
                    }}
                  />
                  <label
                    className="custom-file-label "
                    htmlFor="inputGroupFile01"
                  >
                    {selectedFile ? selectedFile.name : <>Choose file</>}
                  </label>
                </div>
              </CInputGroup>
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom21"
                className="col-sm-12 col-form-label"
              >
                BG ID :
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                min="1"
                onChange={(e) => {
                  setbgid(e.target.value);
                }}
                id="validationCustom21"
                value={bgid ? bgid : " "}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom20"
                className="col-sm-12 col-form-label"
              >
                Amount :
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                min="1"
                type="number"
                onChange={(e) => {
                  setamount(e.target.value < 0 ? 0 : e.target.value);
                }}
                id="validationCustom20"
                value={amount ? amount : " "}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom22"
                className="col-sm-12 col-form-label"
              >
                BG Due Date :
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                onChange={(e) => {
                  setbgduedate(e.target.value);
                }}
                value={bgduedate ? bgduedate : " "}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CButton
                className="ml-3"
                //type="submit"
                //  onClick={submitHandler}
                onClick={() =>
                  ConfirmationPopupHandler(
                    1,
                    -1,
                    "Are you sure you want to proceed?"
                  )
                }
                disabled={
                  selectedFile && amount && bgid && bgduedate ? false : true
                }
                color="success"
              >
                Submit
              </CButton>
              <CButton
                className="ml-3"
                type="submit"
                onClick={backToListViewHandler}
                color="success"
              >
                Back
              </CButton>
              <div>
                <ConfirmationPopup
                  showModal={CPopUpDisplayConfirmationModal}
                  hideModal={handleConfirmationPopUpModalClose}
                  confirmModal={SubmitConfirmationPopUpResponse}
                  id={CPopUpId}
                  index={CPopUpIndex}
                  ModalBody={CPopUpBodyText}
                  // ModalTitle={CPopUpTitle}
                  confirmButtonCss="btn btn-danger"
                  ButtonLoader={false}
                />
              </div>
            </CCol>
          </CRow>{" "}
        </CForm>
      </CCardBody>
    </CCard>
  );
};
export default OfflinePaymentWithType;
